@if (user) {
  <div class="d-flex align-items-center">
    <mtm-user-profile-picture
      [forceLoadProfile]="true"
      [user]="user"
      [username]="user.username"
      [height]="50"
      [width]="50">
    </mtm-user-profile-picture>

    <div class="ms-3">
      <div class="d-flex align-items-center status-wrapper">
        <div class="name-wrapper">
          @if (user.fullName) {
            <div class="name">{{ user.fullName }}</div>
          } @else {
            <div class="username">{{ user.username }}</div>
          }
        </div>

        @if (user.status?.code === 'PENDING_INPROGRESS') {
          <div class="ms-3 new-label">
            {{ 'newUser' | translate }}
          </div>
        }
      </div>

      <div class="job">{{ user.jobTitle }}</div>

      @if (user.status?.code === 'PENDING_INPROGRESS') {
        <div class="status">{{ user.status.label }}</div>
      }
    </div>
  </div>
}
